import { BrowserRouter, Route, Routes } from "react-router-dom";
import About from "./components/About";
import Application from "./components/Application";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Partners from "./components/Partners";
import Projects from "./components/Projects";
import Services from "./components/Services";
import TopBlock from "./components/TobBlock";
import Login from "./components/Admin/Login";
import Admin from "./components/Admin/Admin";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" exact element={<>
                    <Header/>
                    <main id="main">
                        <TopBlock />
                        <Services/>
                        <About />
                        <Partners/>
                        <Projects/>
                        <Application/>
                    </main>
                    <Footer/>
                </>} />
                <Route path="admin">
                    <Route path="" exact element={<Admin />} />
                    <Route path="login" exact element={<Login />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
